import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "./baseUrl";
import { getAuthToken } from "./authSession";
import NotifModal from "./NotifModal";

const EmployeeMessageGate = () => {
  const [queue, setQueue] = useState([]);
  const [current, setCurrent] = useState(null);

  const loadUnreadPopups = useCallback(async () => {
    if (!getAuthToken()) {
      return;
    }

    try {
      const response = await axios.get(`${baseUrl}/notification`);
      const items = response?.data?.data || [];
      const unreadPopups = items.filter(
        (item) => !item.is_read && item.is_popup !== false
      );

      if (unreadPopups.length) {
        setQueue(unreadPopups);
        setCurrent(unreadPopups[0]);
      }
    } catch (error) {
      // ignore when not logged in
    }
  }, []);

  useEffect(() => {
    // Popups are not urgent; wait until the shop list has had time to load.
    const timer = window.setTimeout(() => {
      loadUnreadPopups();
    }, 4000);

    return () => window.clearTimeout(timer);
  }, [loadUnreadPopups]);

  const handleMarkRead = async () => {
    if (!current) {
      return;
    }

    try {
      await axios.post(`${baseUrl}/notification-read/${current.id}`);
    } catch (error) {
      // keep modal open if request fails
      return;
    }

    const remaining = queue.filter((item) => item.id !== current.id);
    setQueue(remaining);
    setCurrent(remaining[0] || null);
  };

  if (!current) {
    return null;
  }

  return (
    <>
      <div className="bg-gray" />
      <NotifModal
        item={current}
        showMarkRead
        onMarkRead={handleMarkRead}
      />
    </>
  );
};

export default EmployeeMessageGate;
